import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

function gameobjectcamera() {

    const camera = new HYPERCUBEJS.Node('camera');

    camera.setcamera(new HYPERCUBEJS.CameraPerspective('frontfar', {

        'angle': 80,
        'near': 0.1,
        'far': 256
    }));
    // camera.setcamera(new HYPERCUBEJS.CameraOrthographic('frontfar', {

    //     'left': -32,
    //     'right': 32,
    //     'bottom': -32,
    //     'top': 32,
    //     'near': -1000,
    //     'far': 1000
    // }));
    camera.translateself([0, 0.5, 2]);
    camera.rotate(HYPERCUBEJS.QUATERNION.fromeuler([

        0 * HYPERCUBEJS.CONSTANTS.RADIANS,
        0 * HYPERCUBEJS.CONSTANTS.RADIANS,
        0 * HYPERCUBEJS.CONSTANTS.RADIANS
    ]));

    return camera;
}

export {

    gameobjectcamera
};

export default gameobjectcamera;
